var React = require('react');

function LogoSingleBlack (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M51.0589 47.92C56.7718 47.92 61.4041 52.552 61.4041 58.2653C61.4041 63.9787 56.7718 68.6107 51.0589 68.6107C45.3453 68.6107 40.7136 63.9787 40.7136 58.2653C40.7136 52.552 45.3453 47.92 51.0589 47.92Z","fill":"#ED1C24","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.7584 81H29.6L50.9374 26.9067L72.324 81H85.1161L51.1474 0.137329L16.7584 81Z","fill":"#231F20","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.661438 33.4947C23.8844 12.6573 79.6161 60.0147 110.377 37.6706C73.3666 71.392 38.0198 23.616 0.661438 33.4947Z","fill":"#ED1C24","key":2})]);
}

LogoSingleBlack.defaultProps = {"width":"111","height":"81","viewBox":"0 0 111 81","fill":"none"};

module.exports = LogoSingleBlack;

LogoSingleBlack.default = LogoSingleBlack;
